import { Component, EventEmitter, OnInit, Output, HostListener, ElementRef , ViewChild, TemplateRef} from '@angular/core';
import {NgbModal, ModalDismissReasons}   from '@ng-bootstrap/ng-bootstrap';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {HttpClient,HttpClientModule,HttpHeaders,} from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ApidataService } from '../apidata.service';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { interval } from "rxjs";
import { IconsFreeToolsComponent } from '../icons-free-tools/icons-free-tools.component';
@Component({
  selector: 'app-savefile',
  standalone: true,
  imports: [NgbDatepickerModule, HttpClientModule,CommonModule,
    ReactiveFormsModule,
    FormsModule,CommonModule,HttpClientModule,FormsModule, 

   ],
  templateUrl: './savefile.component.html',
  styleUrl: './savefile.component.css'
})
export class SavefileComponent {
  closeResult = '';
  file_name: string = '';
  docTitle = "Untitled document";
  saveFileText2 = "";
  savefiletexttt = "";
  profile_id = "";
  doc_id = "";
  visible: boolean = false;
  visibleforsave: boolean = false;

  autosavedlist: boolean = false;
  all_records = [];
  itemsCopy;
  dataListings: any[] = [];
 dataListings2: any[] = [];
 titlelist = [];
 checkdate = [];
 showUndo: boolean = false;
 showRedo: boolean = false;
 Contents;
 wordList;
 lodershow: boolean = false;
 loaderAlert: boolean = false;
 checkingTime = 0;
 addonlyfortesting;
 iLastTime = 0;
 iTime = 0;
 iTotal = 0
 iKeys = 0;
 writtingStarted = 0;
 char_count;
 word_count;
 checkwords: boolean = false;
 dataCurrentArray: Array<any> = [];
 dataUndoArray: Array<any> = [];
 dataRedoArray: Array<any> = [];
 undoLimit: number = 5;
 saveFileText = "";




  constructor(private modalService: NgbModal,
    private router: Router,
    private apiservice: ApidataService,
     private http:HttpClient ,
    private elementRef: ElementRef,) {}
  @ViewChild('content', { static: true }) content: TemplateRef<any>;

  ngOnInit() {
  
    this.openModal();

  }
  openModal() {

    this.modalService.open(this.content, { backdrop: 'static', keyboard: false, centered: true });
  }


  openModels(content:any, data:any=null){
    this.modalService.open(content,{size:"lg"})
    }
    closeModal(){
      this.modalService.dismissAll();
    }

 clearsavebtnk(){
  const value = $("#file_name").val();
if (typeof value === 'string') {
  this.file_name = value;
} else {
 
  this.file_name = ''; 
}
  
  if(this.file_name === this.docTitle){
    this.file_name = this.docTitle
  }
  else{
    this.file_name = '';
    if(!this.file_name){
    this.file_name = this.docTitle
    }
  }
}

 saveFilewithNamenewapi() {
  alert('is calling save?')
  const value = $("#file_name").val();
if (typeof value === 'string') {
  this.file_name = value;
} else {

  this.file_name = ''; 
}
 
if(this.file_name === this.docTitle){
  this.saveFileText = "";

  let Contents = $("#mm").text();

  let sub;
  let subtesting;
  if (Contents) {
    subtesting = interval(20000).subscribe((val) => {
      subtesting;
    });
    this.savefiletexttt = "Saved";
  }

  this.profile_id = localStorage.getItem("profile_id");
  subtesting = this.apiservice
    .getNewDocIDbyProfileIDusingFileNamenew(
      this.profile_id,
      this.file_name,
      this.file_name,
      Contents,
      this.doc_id
    )
    .subscribe((data) => {

      var self = this;

        let receivedData = data;
        this.visible = true;
        this.visibleforsave = true;
        this.autosavedlist = true;
        this.saveDataDoOperations(1);
      
        this.getUserFilesList();

        this.saveFileText = "Saved Successfully!";
        this.savefiletexttt = "Saved";
        $("#savefiletext").show();
        setTimeout(function () {
          $("#savefiletext").hide();
        }, 3000);
        setTimeout(function () {
          $("#savefiletexttt").hide();
        }, 3000);

      
    });
  
}
else{
this.saveFilewithName2();
}
}

 saveFilewithName2() {
  const value = $("#file_name").val();
if (typeof value === 'string') {
  this.file_name = value;
} else {

  this.file_name = ''; 
}

  this.saveFileText = "";

  let Contents = $("#mm").text();

  let sub;
  let subtesting;


  this.profile_id = localStorage.getItem("profile_id");

}

public getUserFilesList() {
  if (typeof localStorage["profile_id"] === "undefined") {
   
  }

  if (localStorage.getItem("profile_id") === null) {
 
  } else {
    this.profile_id = localStorage.getItem("profile_id");

    this.apiservice.getUserFilesListing(this.profile_id).subscribe(
      (data) => this.handleData(data)
    );
  }
}

private handleData(data: Response) {

  if (data.status === 200) {
    let receivedData = data.json();
    if(!this.all_records){
    }
    this.all_records = receivedData["contents"];


    var today_done = "no";
    var yesterday_done = "no";
    var week_done = "no";
    var month_done = "no";
    var early_done = "no";
    for (let i = 0; i < this.all_records.length; i++) {
      if (this.all_records[i][1].length > 0) {
        this.dataListings2.push({
          doc_title: this.all_records[i][1].trim(),
        });
        this.titlelist = this.all_records[i][1];
      }
    }
    this.checkdate = [];
    for (let i = 0; i < this.all_records.length; i++) {
      if (this.all_records[i][8].length > 0) {
        this.checkdate = this.all_records[i][8];
      }
    }
    this.dataListings2 = [];
    this.dataListings = [];

    this.itemsCopy = this.dataListings;
  }
}



 saveDataDoOperations(do_grammar_check) {
  this.checkSpeed(0);
  this.Contents = $("#mm").text();
  this.wordList;
  this.apiservice.saveDataDoOperationsReq(
    this.profile_id,
    this.doc_id,
    this.docTitle,
    this.Contents,
    do_grammar_check,
    this.wordList
  );
  this.loaderAlert = true;
this.check_undo_Redo();
}
checkSpeed(writtingStarted) {
  if (this.checkingTime > 4) {
    this.checkingTime = 0;

  }
  let Contents = $("#mm").text();
  let docTitle = $("#docTitle").text();
  this.addonlyfortesting = Contents.length;

  if (
    (Contents.length > 0 &&
      Contents !== "Start typing your text or paste your text here") ||
    docTitle.length > 0
  ) {
    this.iTime = new Date().getTime();
    if (this.iLastTime !== 0 && writtingStarted == 1) {
      this.writtingStarted = 1;
      this.iKeys++;
      this.iTotal += this.iTime - this.iLastTime;
      if (!Number.isNaN(this.iTotal)) {
        let iWords = $("#mm").text().split(/\s/).length;
        $("#stats_typing_speed").html(
          Math.round((iWords / this.iTotal) * 6000).toFixed(0) + " W/M"
        );
      }
    }
    this.iLastTime = this.iTime;

    this.char_count = $("#mm").text().length;
    let word_count: number = $("#mm").text().trim().split(" ").length;
    localStorage.setItem("dummy", JSON.stringify(this.char_count));
    $("#stats_total_words").html(word_count.toString());
$("#stats_total_chars").html(this.char_count.toString());
$("#char_count").html(word_count.toString());
    if (
      this.char_count > 0
    ) {
      this.checkwords = true;
    } else {
      this.checkwords = false;
    }
    let timeToRead = word_count * 0.46;
    let timeInt = Math.round(timeToRead);
    if (timeInt < 60) {
      $("#stats_total_minutes").html(timeInt.toFixed(0) + " Sec");
    } else {
      $("#stats_total_minutes").html((timeInt / 60).toFixed(0) + " Min");
    }
  }
}
 check_undo_Redo(){

  const elem = document.getElementById('mm');

  if (elem.innerText != '') {
  
    this.showRedo = false;
    if (this.dataCurrentArray.length === 0) {
      this.dataCurrentArray.push(elem.innerText);
    } else {
      if (this.dataUndoArray.length == this.undoLimit) {
        this.dataUndoArray.reverse().pop();
        this.dataUndoArray.reverse();
      }
      this.dataUndoArray.push(this.dataCurrentArray.pop());
      this.dataCurrentArray.push(elem.innerText);
      this.showUndo = true;
    }
  }

}
public saveFile(event: any) {
  if (this.file_name.length > 0) {
    this.saveFileText = "";
  }
}
// save file code end
}
